/* eslint-disable no-unused-vars */
import {
  EAffiliatePartnerUserStatus,
  ECommissionStatus,
  EDocumentSignStatus,
  EIndicationOrigin,
  EIndicationStatus,
  EProposalStatus,
} from "~/graphql/types";

export const pickMonthNameByNumber = (
  value: number,
  type: "short" | "long" = "short",
): string => {
  const MONTH_NUMBER: { [x in number]: string } = {
    1: type === "short" ? "Jan" : "Janeiro",
    2: type === "short" ? "Fev" : "Fevereiro",
    3: type === "short" ? "Mar" : "Março",
    4: type === "short" ? "Abr" : "Abril",
    5: type === "short" ? "Mai" : "Maio",
    6: type === "short" ? "Jun" : "Junho",
    7: type === "short" ? "Jul" : "Julho",
    8: type === "short" ? "Ago" : "Agosto",
    9: type === "short" ? "Set" : "Setembro",
    10: type === "short" ? "Out" : "Outubro",
    11: type === "short" ? "Nov" : "Novembro",
    12: type === "short" ? "Dez" : "Dezembro",
  };

  return MONTH_NUMBER[value] ?? value;
};

const AFFILIATE_PARTNER_USER_STATUS: { [x in EAffiliatePartnerUserStatus]: string } = {
  approved: "Aprovado",
  underAnalysis: "Em análise",
  rejected: "Reprovado",
};

export const translateUserStatus = (status: EAffiliatePartnerUserStatus) => {
  return AFFILIATE_PARTNER_USER_STATUS[status] ?? status;
};

const REFERRALS_STATUS: { [x in EIndicationStatus]: string } = {
  pending: "Indicação solicitada",
  canceled: "Indicação cancelada",
  requestedProposal: "Indicação pendente de dados",
  expiredProposal: "Indicação expirada",
  awaitingSignature: "Indicação pendente assinatura cliente",
  proposalUnderAudit: "Proposta em análise",
  canceledProposal: "Proposta cancelada",
  signedContract: "Contrato aprovado",
  activeContract: "Contrato ativo",
  canceledContract: "Contrato cancelado",
  contractWithPendencies: "Contrato com pendências",
};

export const translateIndicationsStatus = (status: EIndicationStatus) => {
  return REFERRALS_STATUS[status] ?? status;
};

const INDICATIONS_ORIGINS_STATUS: { [x in EIndicationOrigin]: string } = {
  api: "Integração api",
  link: "Link de indicação",
  partnerArea: "Proposta manual",
};

export const translateIndicationsOriginStatus = (status: EIndicationOrigin) => {
  return INDICATIONS_ORIGINS_STATUS[status] ?? status;
};

const COMISSIONS_STATUS: { [x in ECommissionStatus]: string } = {
  canceled: "Cancelado",
  extension: "Prorrogado",
  late: "Atrasado",
  notPaid: "Não Pago",
  paid: "Pago",
};

export const translateComissionsStatus = (status: ECommissionStatus) => {
  return COMISSIONS_STATUS[status] ?? status;
};

const INDICATION_STATUS_DESCRIPTION: { [x in EIndicationStatus]: string } = {
  canceled: "",
  pending: "Sua indicação ainda não virou proposta",
  canceledContract: "Sua indicação foi aceita",
  activeContract: "Confirmado pela concessionária ",
  signedContract: "Aguardando alocação",
  expiredProposal: "Sua indicação não virou proposta",
  proposalUnderAudit: "Proposta em análise",
  requestedProposal: "Sua indicação foi aceita",
  canceledProposal: "Sua indicação não virou proposta",
  awaitingSignature: "Aguardando assinatura",
  contractWithPendencies: "Contrato com pendências",
};

export const descriptionByIndicationStatus = (status: EIndicationStatus) => {
  return INDICATION_STATUS_DESCRIPTION[status] ?? status;
};

const PROPOSAL_STATUS: { [x in EProposalStatus]: string } = {
  documentation: "Documentação",
  formalization: "Formalização",
  finalized: "Contratado",
  canceled: "Cancelado",
};

export function translateProposalStatus(status: EProposalStatus) {
  return PROPOSAL_STATUS[status] ?? status;
}

const MONTHS = {
  january: "Janeiro",
  february: "Fevereiro",
  march: "Março",
  april: "Abril",
  may: "Maio",
  june: "Junho",
  july: "Julho",
  august: "Agosto",
  september: "Setembro",
  october: "Outubro",
  november: "Novembro",
  december: "Dezembro",
};

export enum EMonths {
  "january" = "january",
  "february" = "february",
  "march" = "march",
  "april" = "april",
  "may" = "may",
  "june" = "june",
  "july" = "july",
  "august" = "august",
  "september" = "september",
  "october" = "october",
  "november" = "november",
  "december" = "december",
}

export const translateMonth = (month: EMonths) => {
  return MONTHS[month] ?? month;
};

const DOCUMENT_SIGN_STATUS: { [x in EDocumentSignStatus]: string } = {
  created: "Criado",
  expired: "Expirado",
  pending: "Pendente",
  refused: "Recusado",
  signatureRequested: "Aguardando assinatura",
  signed: "Assinado",
  uploaded: "Em análise",
  error: "Erro",
};

export const translateDocumentSignStatus = (status: EDocumentSignStatus) => {
  return DOCUMENT_SIGN_STATUS[status] ?? status;
};
